export const purchaseUrl = 'https://facial-pro.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/u2hPx8DQwrPVmbwt356nH5/heylloyd-image-1788834288175.png'

export const heroStats = [
  ['+150', 'profesionales confían'],
  ['5', 'Módulos listos'],
  ['3', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'CABA',
    text: 'Organicé todo el año en una tarde. El sistema me ahorra 20 minutos por cliente.',
  },
  {
    initials: 'MP',
    name: 'Micaela P.',
    place: 'Rosario · Cabina propia',
    text: 'Una clienta llegó con una reacción inesperada y la manejé perfectamente. Protocolos claros = confianza profesional.',
  },
  {
    initials: 'LV',
    name: 'Lorena V.',
    place: 'Mendoza · Cosmetóloga',
    text: 'Mis extracciones ahora son perfectas. Menos sangrado, mejores resultados, clientas que vuelven cada 15 días.',
  },
]

export const developedTestimonials = [
  {
    initials: 'CG',
    name: 'Carolina G.',
    place: 'La Plata · 31 años · Cosmetóloga',
    result: 'De 2 a 8 sesiones por clienta al año',
    text: 'Trabajaba de memoria y cada sesión era distinta. Con los Módulos 1 y 2 armé un protocolo fijo de evaluación y limpieza, y en dos meses mis clientas pasaron de venir 2 veces al año a 8. La confianza que transmitís cuando tenés un paso a paso se nota, y eso es lo que las hace volver.',
  },
  {
    initials: 'MT',
    name: 'Mariana T.',
    place: 'Córdoba · 38 años · Dueña de centro de estética',
    result: 'Cero pánico ante casos difíciles',
    text: 'Mi miedo real era la clienta que reacciona mal. Me pasó: enrojecimiento severo a los diez minutos de la extracción. Abrí el manual de situaciones difíciles, seguí el protocolo, la clienta se fue tranquila y volvió al mes. Antes eso me hubiera costado la clienta y la reputación.',
  },
  {
    initials: 'EL',
    name: 'Eugenia L.',
    place: 'Mar del Plata · 42 años · Esteticista facial',
    result: 'Retención del 45% al 89%',
    text: 'Tenía clientas de todo tipo y les hacía casi lo mismo a todas. Con el Módulo 4 cada estado de piel tiene su protocolo y con el Módulo 5 cada clienta se va con su plan de cuidado. En cuatro meses la retención pasó de 45% a 89%. Esa es la diferencia entre tener clientas y tener un negocio.',
  },
  {
    initials: 'RB',
    name: 'Romina B.',
    place: 'Neuquén · 27 años · Recién recibida',
    result: 'Primera cabina llena en 3 meses',
    text: 'Salí del instituto sabiendo teoría pero sin saber qué hacer frente a una piel real. Los Módulos 1 y 2 me dieron el guion completo: qué preguntar, qué mirar, cuándo NO extraer. Abrí mi cabina con seguridad y en tres meses tenía la agenda llena sin gastar un peso en publicidad.',
  },
  {
    initials: 'PA',
    name: 'Patricia A.',
    place: 'Salta · 49 años · 20 años de profesión',
    result: '0 cicatrices post extracción',
    text: 'Después de veinte años pensé que no me quedaba nada por aprender, y me equivoqué. La técnica de extracción del Módulo 3 y el manejo de complicaciones me hicieron cambiar detalles que arrastraba hace años. Desde entonces no volví a tener una sola marca residual en una clienta.',
  },
]

export const modules = [
  {
    icon: '📋',
    name: 'Módulo 1 — Evaluación profesional',
    period: 'Semáforo Verde / Amarillo / Rojo · 10 casos',
    content: [
      'Ficha de evaluación previa paso a paso',
      'Semáforo de decisión: cuándo avanzar y cuándo frenar',
      '10 casos reales resueltos con su criterio',
      'Detección de contraindicaciones en 3 minutos',
    ],
  },
  {
    icon: '🧼',
    name: 'Módulo 2 — Limpieza y preparación',
    period: '4 protocolos · 12 casos resueltos',
    content: [
      '4 protocolos completos de limpieza según biotipo',
      'Preparación de cabina, camilla e insumos',
      'Tiempos exactos de vapor y emoliente',
      '12 casos de piel resueltos con su secuencia',
    ],
  },
  {
    icon: '✨',
    name: 'Módulo 3 — Extracciones profesionales',
    period: 'Técnica + 20 casos + complicaciones',
    content: [
      'Técnica de extracción sin marcas ni sangrado',
      '20 casos: comedones, milium, quistes y más',
      'Manejo de complicaciones en el momento',
      'Qué NO extraer nunca y por qué',
    ],
  },
  {
    icon: '🎯',
    name: 'Módulo 4 — Protocolos según estado de piel',
    period: '8 protocolos específicos + tabla maestra',
    content: [
      'Piel grasa, mixta, seca, deshidratada y reactiva',
      'Acné activo, rosácea y piel madura',
      'Tabla maestra de activos permitidos y prohibidos',
      'Cómo combinar protocolos en una misma sesión',
    ],
  },
  {
    icon: '💚',
    name: 'Módulo 5 — Finalización y clienta recurrente',
    period: 'Cuidados post + guiones + retención',
    content: [
      'Cuidados post sesión día 1, 3 y 7',
      'Guiones exactos para recomendar y agendar',
      'Plan de recurrencia cada 15, 21 y 30 días',
      'Cómo transformar una sesión suelta en un tratamiento',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🚨',
    'Manual de 40 situaciones difíciles',
    'Herpes, reacciones alérgicas, piel reactiva, sangrado, clienta que se descompensa. Qué hacer, qué decir y qué no hacer nunca.',
    '$12.000',
  ],
  [
    '02',
    '📁',
    'Kit de cabina: 15 fichas profesionales',
    'Fichas de evaluación, consentimiento, seguimiento y cierre listas para imprimir y usar desde la próxima sesión.',
    '$12.000',
  ],
  [
    '03',
    '📋',
    '50 protocolos prácticos',
    '50 secuencias completas paso a paso para resolver cualquier piel que entre a tu cabina, sin improvisar.',
    '$14.000',
  ],
] as const

export const pains = [
  'Sesiones sin protocolo claro: trabajás de memoria y sin confianza.',
  'Extracciones que sangran más de lo normal y dejan marcas.',
  'Clientas que se van rojas de la cabina y no vuelven nunca más.',
  'Casos difíciles sin respuesta: herpes, reacciones, piel reactiva.',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Son 5 módulos progresivos de Principiante a Avanzado. Si recién arrancás empezás por el Módulo 1 y 2; si ya trabajás hace años, el Módulo 3 y 4 son los que más te van a mover la aguja.',
  ],
  [
    '¿Cómo recibo el material?',
    'Al pagar recibís un correo automático en menos de 5 minutos con el link de descarga: 5 PDF de módulos + 3 PDF de bonos. Acceso de por vida, los bajás a tu celular o computadora.',
  ],
  [
    '¿Necesito formación previa en estética?',
    'Es recomendable tener la base, pero no es excluyente: los Módulos 1 y 2 enseñan la evaluación y la limpieza desde cero, con fotos, tiempos y checklists.',
  ],
  [
    '¿Sirve para piel sensible o reactiva?',
    'Totalmente. Hay un protocolo específico para piel reactiva dentro del Módulo 4 y el Bono 1 cubre las 40 situaciones difíciles más frecuentes, incluidas las reacciones en cabina.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días. Escribís a compradigitalyaa@gmail.com y te devolvemos el 100%, sin justificaciones ni formularios. La tasa de devoluciones es menor al 0,5%.',
  ],
  [
    '¿Cómo puedo pagar?',
    'En pesos argentinos con Mercado Pago, tarjeta de crédito o débito y transferencia bancaria, con cuotas según tu banco.',
  ],
  [
    '¿Incluye la parte de extracciones?',
    'Sí, el Módulo 3 está dedicado íntegramente a extracciones: técnica, presión, ángulo, 20 casos resueltos y el manejo de complicaciones cuando algo no sale como esperabas.',
  ],
  [
    '¿Me sirve si trabajo a domicilio y no tengo cabina?',
    'Sí. El Kit de Cabina incluye la versión reducida de insumos y las fichas imprimibles funcionan igual a domicilio. Los protocolos no dependen de aparatología.',
  ],
  [
    '¿Es contenido en video o PDF?',
    'Es 100% PDF profesional, pensado para imprimir o consultar desde el celular durante la sesión. Son 370+ páginas entre módulos y bonos.',
  ],
  [
    '¿Puedo usarlo para capacitar a mi equipo?',
    'Sí, podés usarlo internamente para estandarizar los protocolos de tu centro. Lo que no está permitido es revenderlo o redistribuirlo fuera de tu equipo.',
  ],
] as const

export const recentPurchases = [
  ['Camila Ferreyra', 'Rosario, Santa Fe'],
  ['Julieta Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustina Rojas', 'Godoy Cruz, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Daniela Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén Capital, Neuquén'],
  ['Natalia Ojeda', 'Salta Capital, Salta'],
  ['Florencia Alsina', 'Bahía Blanca, Buenos Aires',],
  ['Micaela Duarte', 'Posadas, Misiones'],
] as const
